import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  AddActionCallbackInput,
  AddActionDialog,
  AddActionDialogUniqueProps,
} from '../AddActionDialog';

const { useDialogForContext, useDialog: useAddActionDialog } = getDialogHooks<
  AddActionDialogUniqueProps,
  AddActionCallbackInput
>(AddActionDialog);
export const useAddActionDialogForContenxt = useDialogForContext;
export default useAddActionDialog;
